/**
 * WordPress dependencies
 */
import { store, getContext } from '@wordpress/interactivity';

store('big-bite-stats-perform/match-tabs', {
  state: {
    get isActive() {
      const context = getContext();
      const { state } = store('big-bite-stats-perform/match-tabs');
      return state.activeTab === context.tabId;
    },
  },
  actions: {
    setActiveTab: () => {
      const context = getContext();
      const { state } = store('big-bite-stats-perform/match-tabs');
      state.activeTab = context.tabId;
    },
  },
});
